import isCaseOpen from './isCaseOpen';

function isCaseClosed(theCase = {}) {
  return !isCaseOpen(theCase);
}

export default isCaseClosed;
